<template>
<a class="mouse-p" @click="checkLoginState" :scope="scope">
    <slot></slot>
</a>     
</template>
<script>
import sdk from "./fb_sdk"
export default {
    data(){
        return {
            scope:sdk.scope
        }
    },	
    methods:{        
        checkLoginState(){
            //检测是否登录
            try {
                // eslint-disable-next-line no-undef
                FB.getLoginStatus((response) => {
                    if(!response.authResponse){
                        // eslint-disable-next-line no-undef
                        FB.login((response)=>{
                        // handle the response 
                            this.handleLogin(response)
                        },{scope:this.scope});
                    }else{
                        this.handleLogin(response)
                    }
                },true);     
            } catch (error) {
                console.log(error)
            }
             
        },
        handleLogin(res){
            try {
                this.$http.post(window.PASSPORTURL + "/auth/thirdInfo",{userId:res.authResponse.userID,token:res.authResponse.accessToken,type:'facebook'},{headers: {"Content-Type": "application/json"}}).finally(()=>{
                    this.$alert.loading(false);
                }).then((res)=>{
                    this.$emit("thirdinfo",res);
                })
            }catch(error){
                console.log(error)
            }
        }
    }
}
</script>
